export default "__VITE_ASSET__y6xmd2z4__"